/**
 * Hostnames that are the platform itself, as opposed to a brand's custom
 * domain. On these hosts the app keeps the default Frankly identity and
 * skips custom-domain brand resolution.
 *
 * Was duplicated in useBrand.tsx and useDomainBrand.ts until the two copies
 * drifted (prototype.* existed in one but not the other) — single source now.
 */
const PLATFORM_HOSTNAMES = new Set([
  'localhost',
  'franklyadvisors.com',
  'www.franklyadvisors.com',
  'app.franklyadvisors.com',
  'dev.franklyadvisors.com',
  'dev-app.franklyadvisors.com',
  'prototype.franklyadvisors.com',
]);

const IPV4_LITERAL = /^\d{1,3}(\.\d{1,3}){3}$/;

export function isPlatformDomain(hostname: string): boolean {
  return (
    PLATFORM_HOSTNAMES.has(hostname) ||
    hostname.endsWith('.vercel.app') ||
    // IP literals are always the platform: a brand custom_domain is a DNS
    // name, while raw IPs are how dev servers get reached (127.0.0.1, LAN,
    // Tailscale). Without this, a logged-in user on an IP origin hits the
    // DomainGate "Access Denied" screen.
    IPV4_LITERAL.test(hostname) ||
    hostname.startsWith('[') // IPv6 literal, e.g. [::1]
  );
}
